export default "__VITE_ASSET__CaO8fq1A__"